<template>
  <transition name="slide-fade">
    <div v-show="messageTotalRequests" class="fixed-bottom">
      <div
        :class="`alert alert-danger mb-0 hideRequests ${cssSlideRequests}`"
        role="alert"
      >
        <div class="d-flex align-items-center">
          {{ messageTotalRequests }}
          <div v-if="showRequests">
            <b-button
              variant="light"
              @click="closeRequests"
              class="float-right"
              size="sm"
              >Fechar</b-button
            >
          </div>
          <div v-else>
            <b-button
              variant="light"
              @click="openRequests"
              class="float-right"
              size="sm"
              >Ver</b-button
            >
          </div>
        </div>
        <div class="mt-3" v-show="showRequests">
          <ul style="list-style: none; padding:0px">
            <li
              v-for="(item, index) in $store.state.requests"
              :key="index"
              class="d-flex mt-2 justify-content-between"
            >
              <div style="width: 80%">
                {{
                  item.vuex ? `O.S: ${item.data.id} - ${item.vuex.name}` : ""
                }}
              </div>
              <div>
                <button
                  @click="removeLocalStorage(index)"
                  class="btn btn-sm btn-light"
                >
                  Excluir
                </button>
              </div>
            </li>
          </ul>
          <b-button
            variant="light"
            class="w-full"
            size="md"
            @click="forceSync()"
            style="width: 100%"
            >Sincronizar tudo</b-button
          >
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import SynchronizationMixin from "@/mixins/synchronization"

export default {
  data() {
    return {
      cssSlideRequests: "",
      showRequests: false,
    }
  },
  watch: {
    messageTotalRequests(value) {
      if (!value) {
        this.showRequests = false
        this.cssSlideRequests = ""
      }
    },
  },
  computed: {
    messageTotalRequests() {
      if (this.$store.state.requests?.length && !this.$route.meta.public) {
        return `Você possui ${this.$store.state.requests.length} requisições esperando sincronização!`
      }
      return false
    },
  },
  mixins: [SynchronizationMixin],
  methods: {
    openRequests() {
      this.showRequests = true
      this.cssSlideRequests = "showRequests"
    },
    async forceSync() {
      try {
        if (!navigator.onLine) {
          return this.$swal().error("Você não possui internet!")
        }

        await this.syncServer(this.$store.state.requests)

        this.$swal().success("Seus dados foram sincronizados com sucesso!")
      } catch (err) {
        this.$swal().error(err)
      }
    },
    removeLocalStorage(index) {
      const cache = this.$store.state.requests
      const newCache = []
      for (const i in cache) {
        if (index != i) {
          newCache.push(cache[i])
        }
      }

      this.$store.commit("updateStorage", newCache)
      location.reload()
    },
    closeRequests() {
      this.showRequests = false
      this.cssSlideRequests = ""
    },
  },
}
</script>

<style>
.hideRequests {
  height: auto;
  transition: height 0.5s;
}

.showRequests {
  height: 100vh;
  transition: height 0.5s;
}
/* Animações de entrada e saída podem utilizar diferentes  */
/* funções de duração e de tempo.                          */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active em versões anteriores a 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}
/* fade down */
/* Animações de entrada e saída podem utilizar diferentes  */
/* funções de duração e de tempo.                          */
.slide-fade-down-enter-active {
  transition: all 0.3s;
}
.slide-fade-down-leave-active {
  transition: all 0.3s;
}
.slide-fade-down-enter, .slide-fade-down-leave-to
/* .slide-fade-leave-active em versões anteriores a 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
